import {
  type EditToolLayoutValues,
  type TourFrame,
  type TourStep,
  tooltipDefaultConfig,
} from '@carboncopyco/types';
import { pickInitialTooltipPlacement } from './overflowCalculations';

export const buildDefaultTooltipConfigObject = ({
  xpath,
  elementPosition,
  frameType,
  preferredLayout,
}: {
  xpath?: TourStep['xpath'];
  elementPosition?: TourStep['elementPosition'];
  frameType: TourFrame['frameType'];
  preferredLayout?: EditToolLayoutValues;
}) => {
  if (!document) {
    return { tooltip: tooltipDefaultConfig };
  }

  const pickedInitialPlacement = pickInitialTooltipPlacement({
    xpath,
    elementPosition,
    frameType,
  });

  return {
    tooltip: {
      ...tooltipDefaultConfig,
      balloon: {
        ...tooltipDefaultConfig.balloon,
        layout: preferredLayout || pickedInitialPlacement,
      },
    },
  };
};
